import { useState } from "react";
import CustomCard from "./Card";
import PersonSignupForm from "./PersonSignupForm";
import SuccessSignup from "./SuccessSignUp";

function PersonSignup() {
  const [level, setLevel] = useState(1);
  return (
    <>
      {level !== 6 && (
        <CustomCard
          title={
            level === 1
              ? "ثبت نام جهادگر"
              : level === 2
              ? "وارد کردن کد تأیید"
              : level === 3
              ? "اطلاعات شخصی جهادگر"
              : level === 4
              ? "اطلاعات عمومی جهادگر"
              : "اطلاعات آشنایان جهادگر"
          }
          subTitle={
            level === 1
              ? "لطفا ابتدا شماره تلفن همراه خود را وارد کنید."
              : level === 2
              ? "کد به شماره تلفن وارد شده ارسال شد."
              : level === 3 || level === 4
              ? "لطفا اطلاعات خود را به دقت تکمیل کنید."
              : " برای ارتباط در شرایط خاص، لطفاً اطلاعات یکی از آشنایان خود را بنویسید."
          }
        >
          <PersonSignupForm level={level} setLevel={setLevel} />
        </CustomCard>
      )}

      {level === 6 && <SuccessSignup />}
    </>
  );
}

export default PersonSignup;
